import { useAtom } from 'jotai';
import { useCallback } from 'react';

import { NetSuiteFieldsExpenseReport } from '../../../data/types';
import { setCurrencyPrecision } from '../../../helpers';
import { useChangeNetSuiteRequest, useCurrencyPrecision } from '../../../hooks';
import { netSuiteExpenseReportFieldValuesState } from '../../NetSuiteExpenseReportRequestForm.states';

export const useExpenseReportFieldValues = () => {
    const [{ currency }, setFieldValues] = useAtom(netSuiteExpenseReportFieldValuesState);

    const currencyPrecision = useCurrencyPrecision(currency);

    const changeNetSuiteRequest = useChangeNetSuiteRequest();

    const setFieldValue = useCallback<
        <K extends keyof NetSuiteFieldsExpenseReport>(key: K, value: NetSuiteFieldsExpenseReport[K]) => void
    >(
        (key, value) => {
            setFieldValues((current) => {
                if (key === 'advance') {
                    return {
                        ...current,
                        advance: setCurrencyPrecision(value, currencyPrecision),
                    };
                }

                return { ...current, [key]: value };
            });

            changeNetSuiteRequest();
        },
        [currencyPrecision, changeNetSuiteRequest, setFieldValues]
    );

    return {
        setFieldValue,
    };
};
